const storage = {
	get: (key) => {
		if (!window) return;

		let obj = window.localStorage.getItem(key);
		if (!obj) return null;

		return JSON.parse(obj);
	},
	set: ({ key, value }) => {
		if (!window) return;

		if (!key || !value) return null;

		let obj = window.localStorage.getItem(key);

		if (!obj) obj = {};
		if (obj && typeof obj !== 'object') obj = JSON.parse(obj);

		obj[key] = value;

		window.localStorage.setItem(key, JSON.stringify(value));

		return obj;
	},
};

export default {
	/**
	 * Creates aribtrary wait time based on miliseconds
	 * @param { int } milliseconds
	 * @return { promise } resolves once time has been reached
	 * */
	asyncTimeout: function (ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	},
	/**
	 * Converts Hex colors withhout "#" to RGB
	 * @params { string } hex - hex code
	 * @params { float } alpha - number between 0 and 1 for opacity
	 * @return { string } rgba value
	 * */
	hex2rgba: function (hex, alpha = null) {
		const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
		if (alpha && alpha !== null) {
			return `rgba(${r},${g},${b},${alpha})`;
		}
		return `rgb(${r},${g},${b})`;
	},
	/**
	 * Creates random uniqe id
	 */
	uuidv4: function () {
		return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
			(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
		);
	},
	/**
	 * Sets non persistent state with getters and settes
	 * @param { object } init - initial values ex: { name: 'Dave' }
	 * @return { object } state in its current form
	 *
	 * How to use
	 * Initialize state:
	 * const state = new solver.each.state({ name: 'Dave', city: 'Austin' });
	 * Update state: state.name = 'Tim';
	 */
	state: function (init = null) {
		if (!init) return;

		this.state = {};

		for (const s in init) {
			this.state['_' + s] = init[s];
			Object.defineProperty(this.state, s, {
				get() {
					return this['_' + s];
				},
				set(value) {
					this['_' + s] = value;
					return this['_' + s];
				},
			});
		}

		return this.state;
	},
};
